// extracted by mini-css-extract-plugin
module.exports = {"cp-colorpicker__modal":"styles_cp-colorpicker__modal__3slFW"};